<ziro-loading-block [hidden]="!isLoading"></ziro-loading-block>
@if (!isLoading) {
  <ziro-collapsible-section-card [isSwitchHidden]="true" [isCollapsible]="false">
    <div class="col-12 pb-5">
      <div class="mx-4 flex-grow-1">
        <ziro-snr-destinations-form
          [entity]="snrDestinations"
          [cucmServerId]="cucmServerId"
          [initialSnrDestinations]="snrDestinations"
          (ziroFormsUpdate$)="onDestinationsValidationStateChange($event)"
          [parentSubmit$]="parentSubmit$"
          [isErrorThrown]="_isSnrDestinationsUpdated && isErrorThrown"
        ></ziro-snr-destinations-form>
        <ziro-snr-profile-form
          [fieldConfig]="snrFieldConfig"
          [entity]="snrProfile"
          (ziroFormsUpdate$)="onProfileValidationStateChange($event)"
          [parentSubmit$]="parentSubmit$"
          [isErrorThrown]="_isSnrProfileUpdated && isErrorThrown"
          [cucmServerId]="cucmServerId"
        ></ziro-snr-profile-form>
        <div>
          <legend>{{ 'tkey;snr.snrprofile.lines.label' | translate }}</legend>
          <div class="mb-3 row">
            <label
              class="col-form-label col-lg-3 text-lg-end ziro-forms-label border-rad-all-8"
              for="extension"
              data-automation="ziro-text-label"
            >
              <span>{{ 'tkey;snr.snrprofile.extension.label' | translate }}</span>
            </label>
            <form class="col-lg-9">
              <div
                class="input-group h-100"
                [ngbTooltip]="'tkey;snr.snrprofile.lines.extensiondisabled.label' | translate"
              >
                <input
                  class="form-control extension-input"
                  id="extension"
                  type="text"
                  [disabled]="true"
                  placeholder=" {{ primaryExtension.extension | telephoneNumberFilter }}"
                />
              </div>
            </form>
          </div>
        </div>
        <ziro-phone-buttons-line-helpdesk-form
          [fieldConfig]="lineFeatureFieldConfig"
          [entity]="snrProfileLine"
          (ziroFormsUpdate$)="onProfileLineValidationStateChange($event)"
          [parentSubmit$]="parentSubmit$"
          [isErrorThrown]="false"
        ></ziro-phone-buttons-line-helpdesk-form>
      </div>
    </div>
  </ziro-collapsible-section-card>
}
